import useSWR from 'swr';

import { SWR_GLOBAL_CONFIG } from '~/api/_constant';
import { request } from '~/api/_utils/request';
import { CompetitionT } from '~/state/competition';

import { ApiCompetitionShow } from '../../organizations/[id]/competitions/get';

const getPath = (id?: string | number) => `/v1/competitions/${id}`;

export async function apiGetV1CompetitionById(id?: string | number) {
  if (!id) return;
  const { competition } = await request.GET<{ competition: ApiCompetitionShow }>(getPath(id));
  return competition;
}

export function useSWRV1CompetitionById(id?: string | number) {
  const swr = useSWR(getPath(id), () => apiGetV1CompetitionById(id), SWR_GLOBAL_CONFIG);
  return {
    ...swr,
    competition: swr.data,
    competitionLegacyType: swr.data as CompetitionT | undefined,
  };
}
